export function mapTurnoverBonus(retr) {
    if (!retr) {
        return {}
    }
    return {
        list: [
            {
                rows: [
                    {
                        name: 'Wartość obrotu',
                        value: retr.value
                    },
                    {
                        name: 'Wartość premii - korekta',
                        value: retr.adjustment,
                        percent: retr.adjustmentPercent,
                        bold: true
                    }
                ]
            },
            {
                rows: [
                    {
                        name: 'Wartość premii - faktura',
                        value: retr.invoice,
                        percent: retr.invoicePercent,
                        bold: true
                    }
                ]
            }
        ]
    }
}

export function mapPaymentTermBonus(retr) {
    if (!retr) {
        return {}
    }
    return {
        list: [
            {
                rows: [
                    {
                        name: 'Wartość obrotu płatności standard',
                        value: retr.standardPaymentValue
                    },
                    {
                        name: 'Premia płatności standard',
                        value: retr.standardPaymentBonus,
                        percent: retr.standardPaymentBonusPercent,
                        bold: true
                    }
                ]
            },
            {
                rows: [
                    {
                        name: 'Wartość obrotu płatności do 3 dni',
                        value: retr.to3DaysPaymentValue
                    },
                    {
                        name: 'Premia płatności do 3 dni',
                        value: retr.to3DaysPaymentBonus,
                        percent: retr.to3DaysPaymentBonusPercent,
                        bold: true
                    }
                ]
            },
            {
                rows: [
                    {
                        name: 'Obrót niepremiowany',
                        value: retr.nonBonus
                    }
                ]
            }
        ]
    }
}

export function mapClaimsAdjustments(retr) {
    if (!retr) {
        return {}
    }
    return {
        list: [
            {
                name: 'REKLAMACJE',
                valueSum: retr.reclamationsValueSum,
                list: (retr.reclamations || []).map(reclamation => {
                    return {
                        name: reclamation.name,
                        value: reclamation.value
                    }
                })
            },
            {
                name: 'DOLICZENIA',
                valueSum: retr.adjustmentsValueSum,
                list: (retr.adjustments || []).map(adjustment => {
                    return {
                        name: adjustment.name,
                        value: adjustment.value
                    }
                })
            }
        ]
    }
}